<template>
    <div
        id="app"
        class="app">
        <router-view />

        <div
            v-if="!isProductionMode"
            class="container mt-5">
            viewportInnerWidth: {{ `${viewportInnerWidth}px` }}<br>
            viewportNoMatch: {{ viewportNoMatch }}<br>
            viewportIsLarge: {{ viewportIsLarge }}<br>
            isInEditMode: {{ isInEditMode }}<br>
            hasAnyValueChangeInEditMode: {{ hasAnyValueChangeInEditMode }}<br><br>
            <br>
            <button
                class="btn btn-secondary mb-2 mt-2"
                @click="onScrollToTop">
                iFrame test: Scroll to top
            </button><br>
            <a
                class="btn btn-secondary"
                @click="callEditMode"
                href="#">Call app in edit mode
            </a><br><br>
        </div>

        <v-breakpoint
            @change="setViewport" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import iframeResizer from 'iframe-resizer/js/iframeResizer.contentWindow.js';
import { scrollTo } from '@/services/scrollToService';
import WindowInstance from '@/components/common/WindowInstance';
import iframeService from '@/services/iframeService';

export default {
    name: 'App',
    data () {
        return {
            isProductionMode: process.env.NODE_ENV === 'production',
        };
    },
    computed: {
        ...mapGetters(['viewportNoMatch', 'viewportIsLarge', 'editConfiguration', 'isInEditMode', 'hasAnyValueChangeInEditMode', 'selectedLanguage']),
        viewportInnerWidth () {
            return WindowInstance.innerWidth;
        },
    },
    mounted () {
        window.iFrameResizer = {
            readyCallback: () => {
                // Store iframe params from host page
                window.parentIFrame.getPageInfo(params => {
                    this.setIframeParams(params);
                });
            },
            messageCallback: message => {
                if (message === 'RESIZE_EVENT_EXECUTED') {
                    iframeService.resetIframeIsResizing(); // reset the flag to allow triggering the scrolling event within iframe
                }
            },
        };
        window.iframeResizer = iframeResizer;
        this.setScreenSource(this.$route.query.screensource);
        this.fetchSettings();
        this.handleEditMode();
        this.loadTranslations(this.selectedLanguage);
    },
    methods: {
        ...mapActions(['loadTranslations', 'reset', 'setIsUserNewOnPage', 'setIframeParams', 'setViewport', 'handleEditMode', 'fetchSettings', 'setScreenSource']),
        onScrollToTop () {
            this.$nextTick(() => {
                scrollTo(0, 0);
            });
        },
        callEditMode () {
            /*  Example link for Edit Mode:
                /onlineassetmanagement/#/?Valuelist=ASj5cJm5:10:100000:2:1:0:1:5:3:2:1:2:3

                EditToken---:A-:B-----:C:D:E:F:G:H:I:J:K:L

                A: investmentHorizon
                B: investmentAmount
                C: investmentObjective
                D: investmentTopic
                E: otherInvestments
                F: investmentRegion
                G: investmentStrategy
                H: strategyByInvestmentHorizon
                I: (optional) strategyByRiskTolerance
                J: (optional) riskToleranceBlock1SelectedAnswer
                K: (optional) riskToleranceBlock2SelectedAnswer
                L: (optional) riskToleranceBlock3SelectedAnswer
             */
            const editRequestUrl = '/onlineassetmanagement/#/?Valuelist=np6TWcM1596732295347:5:100000:3:0:1:0:2:3:2:0:0:0';
            window.location.href = editRequestUrl;
            window.location.reload();
        },
    },
};
</script>
